import { motion } from "framer-motion";
import { IMG } from "../data/show";

const BAKED = { [IMG.welcome]: "459/428", [IMG.pr]: "760/251", [IMG.hilltop]: "463/426" };

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light }) => (
  <p className={`eyebrow ${light ? "text-[var(--sun)]" : ""}`}>{children}</p>
);

export const Quote = ({ q, testid, dark }) => (
  <blockquote className={`pull-quote ${dark ? "is-dark" : ""}`} data-testid={testid}>
    <p>&ldquo;{q.text}&rdquo;</p>
    <cite>— {q.by}</cite>
  </blockquote>
);

export const Slate = ({ src, label, className = "", testid }) => (
  <figure className={`slate-frame ${className}`} style={BAKED[src] ? { aspectRatio: BAKED[src] } : undefined} data-testid={testid}>
    <img src={src} alt={label} loading="lazy" />
    {!BAKED[src] && <figcaption className="slate-label">{label}</figcaption>}
  </figure>
);

export const PageHero = ({ eyebrow, title, sub, testid }) => (
  <section className="page-hero" data-testid={testid}>
    <div className="wrap">
      <Reveal>
        <Eyebrow light>{eyebrow}</Eyebrow>
        <h1 className="display text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-4xl">{title}</h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-white/75">{sub}</p>
      </Reveal>
    </div>
  </section>
);
